var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCybericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 66,
    viewBox: "0 0 68 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7525 47.0214C53.4616 45.8126 53.1548 44.5078 52.8459 43.0551C50.9766 34.2883 49.268 34.1268 48.373 33.6401C47.478 33.1524 37.797 28.2031 37.797 28.2031L33.5347 30.475V47.0214H53.7525Z",
    fill: "url(#paint0_linear_254_7176)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5337 47.0214V30.475L29.2661 28.2031C29.2661 28.2031 19.5882 33.1524 18.6943 33.6401C17.7993 34.1268 16.0908 34.2883 14.2193 43.0551C13.9083 44.5078 13.6036 45.8126 13.3137 47.0214H33.5337Z",
    fill: "url(#paint1_linear_254_7176)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6172 23.0798L33.5008 22.5488L37.3855 23.0798C37.3855 23.0798 37.0998 26.5775 37.797 28.2023C37.797 28.2023 35.7023 30.6357 33.5008 30.4742C31.3024 30.6346 29.2046 28.2023 29.2046 28.2023C29.9039 26.5764 29.6172 23.0798 29.6172 23.0798Z",
    fill: "#F4C297"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1359 14.5002H25.3042C25.2322 13.9312 25.1613 13.3706 25.0926 12.8395C24.735 10.0925 23.9257 2.06055 33.5348 2.06055C43.1428 2.06055 42.3345 10.0925 41.9748 12.8395C41.9061 13.3706 41.8352 13.9312 41.7664 14.5002H41.9304C43.3914 13.4212 43.5173 16.2411 42.9058 17.2039C42.4001 18.001 42.3885 18.0886 42.0859 18.9659C41.8606 19.6141 41.4871 19.7007 41.175 19.63C41.1348 20.0111 41.101 20.3478 41.0788 20.6139C40.9423 22.0961 37.3729 25.0659 36.5636 25.996C35.8061 26.8638 34.544 26.5239 34.1378 26.507C33.7294 26.4858 33.5348 26.4764 33.5348 26.4764C33.5348 26.4764 33.338 26.4869 32.9286 26.507C32.5245 26.5239 31.2623 26.8638 30.5049 25.996C29.6934 25.0659 26.124 22.0972 25.9907 20.6139C25.9664 20.3478 25.9347 20.0122 25.8924 19.63C25.5813 19.7007 25.2079 19.6141 24.9847 18.9659C24.6779 18.0886 24.6683 18.001 24.1616 17.2039C23.5522 16.2411 23.676 13.4212 25.1359 14.5002Z",
    fill: "url(#paint2_linear_254_7176)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4639 13.5914C25.4639 14.0781 26.3399 17.9156 26.4869 19.1402C26.7673 21.4639 28.4399 22.5471 28.9265 23.0813C29.4153 23.6155 31.0243 24.1529 31.7078 24.3957C32.3912 24.6396 34.6784 24.6396 35.3597 24.3957C36.0431 24.1529 37.6533 23.6155 38.141 23.0813C38.6276 22.5471 40.3002 21.4639 40.5784 19.1402C40.7276 17.9156 41.6025 14.0781 41.6025 13.5914C41.6025 13.2662 41.7612 13.3855 41.8575 13.7592C41.8257 14.0052 41.7961 14.2522 41.7665 14.5003C41.7665 14.5003 41.2629 19.6523 41.1751 19.6301C41.1349 20.0112 41.101 20.348 41.0788 20.6141C41.0651 20.745 41.0206 20.8875 40.9614 21.0342C40.7805 21.3172 40.498 21.7754 40.1415 22.3233C38.9884 23.7475 37.1243 25.3543 36.5647 25.9951C35.8072 26.8629 34.5451 26.523 34.1389 26.5061C33.7305 26.485 33.5359 26.4755 33.5359 26.4755C33.5359 26.4755 33.3391 26.486 32.9297 26.5061C32.5256 26.523 31.2635 26.8629 30.506 25.9951C29.9485 25.3543 28.0812 23.7464 26.9291 22.3233C26.5726 21.7764 26.2902 21.3172 26.1082 21.0342C26.05 20.8864 26.0035 20.745 25.9929 20.6141C25.9686 20.348 25.9368 20.0123 25.8945 19.6301C25.8067 19.6523 25.3063 14.5003 25.3063 14.5003C25.2724 14.2522 25.2418 14.0052 25.2122 13.7592C25.3063 13.3855 25.4639 13.2673 25.4639 13.5914Z",
    fill: "#582D11"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9819 21.8023C32.0578 20.829 33.5336 20.5703 33.5336 20.5703C33.5336 20.5703 35.0094 20.829 36.0832 21.8023C37.158 22.7757 36.0832 24.5282 36.0832 24.5282L35.8451 24.2221C37.0057 21.8773 33.5336 21.7379 33.5336 21.7379C33.5336 21.7379 30.0615 21.8773 31.2189 24.2221L30.9808 24.5282C30.9808 24.5282 29.9071 22.7757 30.9819 21.8023Z",
    fill: "#582D11"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7507 24.3973C33.0871 24.0753 33.5336 24.1259 33.5336 24.1259C33.5336 24.1259 33.9779 24.0753 34.3143 24.3973C34.6507 24.7235 35.3648 24.4839 35.3648 24.4839L33.9261 25.6641L33.5336 25.2757L33.14 25.6641L31.7034 24.4839C31.7034 24.4839 32.4154 24.7225 32.7507 24.3973Z",
    fill: "#582D11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6836 0C26.6836 0 26.2954 1.08 34.489 1.08C34.4943 1.08 34.4953 1.08107 34.5006 1.08107C34.6677 1.08107 34.8518 1.08529 35.0539 1.09901C42.892 1.44001 42.4657 8.89029 42.4657 8.89029L42.454 8.88394C42.5154 10.7579 42.1261 12.6328 41.7664 14.5004L41.6024 13.5914C41.6024 13.5914 41.5231 12.6898 41.1602 11.5855C41.1391 11.5254 41.1189 11.4694 41.0978 11.4114C40.9899 11.1073 40.8608 10.7906 40.7095 10.4739C38.5778 6.23619 33.5347 7.61601 33.5347 7.61601C33.5347 7.61601 28.4874 6.23514 26.3557 10.4792C26.2065 10.7885 26.0817 11.0957 25.9759 11.3966C25.9526 11.4631 25.9293 11.5243 25.9082 11.5919C25.5474 12.692 25.4649 13.5925 25.4649 13.5925L25.3052 14.5015C25.0767 13.3317 24.8386 12.1578 24.7064 10.9827C24.7064 10.9775 24.7043 10.9711 24.7043 10.9627C23.8156 4.73704 26.6836 0 26.6836 0Z",
    fill: "#582D11"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5337 30.475L36.5604 33.9252L39.4401 29.0424L37.796 28.2031C37.796 28.2031 35.366 30.0675 33.5337 30.475Z",
    fill: "url(#paint3_linear_254_7176)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5337 30.475L30.5049 33.9252L27.6252 29.0424L29.2661 28.2031C29.2661 28.2031 31.7035 30.0675 33.5337 30.475Z",
    fill: "url(#paint4_linear_254_7176)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0604 33.9256L35.0316 32.1826L33.5336 30.4766L32.0345 32.1826L33.0057 33.9256L31.7034 42.4549L33.5336 45.3613L35.3659 42.4549L34.0604 33.9256Z",
    fill: "url(#paint5_linear_254_7176)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7578 48.8819C46.6859 48.8819 46.5674 48.9062 46.4108 48.9548C46.3738 48.9674 46.3262 48.9801 46.2828 48.997C43.7692 49.8225 33.5349 54.9956 33.5349 54.9956V44.9841L41.7846 30.2399L42.0882 30.2188C44.4886 31.4761 47.7396 33.1896 48.5309 33.6467C49.2566 34.0732 49.8321 34.8238 50.7419 36.1699C51.4476 37.2172 52.351 38.6202 53.6872 40.5163C56.7541 44.8617 59.9755 51.1338 59.9755 51.1338C59.9755 51.1338 63.3597 55.9595 59.9755 58.2113C58.7007 59.0633 56.5298 60.155 54.3198 61.1843C50.9007 62.7869 47.3915 64.2406 46.9641 64.4137C46.9387 64.4264 46.9144 64.4338 46.9144 64.4338V64.4137L46.6171 62.619L46.0638 59.2629L45.4682 55.6364C45.4682 55.6364 45.7041 55.5932 46.0638 55.5161C46.4944 55.4285 47.1038 55.2923 47.7396 55.1202C49.1202 54.7539 50.5917 54.2281 50.432 53.7066C50.141 52.7437 47.8856 48.8819 46.7578 48.8819Z",
    fill: "url(#paint6_linear_254_7176)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3098 48.8819C20.3849 48.8819 20.5024 48.9062 20.6558 48.9548C20.696 48.9674 20.7415 48.9801 20.788 48.997C23.3027 49.8225 33.5349 54.9956 33.5349 54.9956V44.9841L25.2852 30.2399L24.9805 30.2188C22.5791 31.4761 19.3302 33.1896 18.5378 33.6467C17.811 34.0732 17.2408 34.8238 16.3278 36.1699C15.6222 37.2172 14.7166 38.6202 13.3815 40.5163C10.3209 44.8617 7.09324 51.1338 7.09324 51.1338C7.09324 51.1338 3.70895 55.9595 7.09324 58.2113C8.36909 59.0633 10.5389 60.155 12.751 61.1843C16.1681 62.7869 19.6772 64.2406 20.1046 64.4137C20.131 64.4264 20.1543 64.4338 20.1543 64.4338V64.4137L20.4516 62.619L21.0028 59.2629L21.6026 55.6364C21.6026 55.6364 21.3625 55.5932 21.0028 55.5161C20.5754 55.4285 19.9671 55.2923 19.3302 55.1202C17.9486 54.7539 16.4759 54.2281 16.6357 53.7066C16.9277 52.7437 19.1853 48.8819 20.3098 48.8819Z",
    fill: "url(#paint7_linear_254_7176)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5587 64.4899C47.5587 65.193 46.9895 65.7652 46.285 65.7652H20.8526C20.1448 65.7652 19.5757 65.193 19.5757 64.4899C19.5757 63.7878 20.1448 63.2188 20.8526 63.2188H46.285C46.9895 63.2188 47.5587 63.7878 47.5587 64.4899Z",
    fill: "url(#paint8_linear_254_7176)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5587 62.4491C47.5587 63.1195 47.0139 63.6632 46.3442 63.6632H20.7923C20.1184 63.6632 19.5757 63.1185 19.5757 62.4491V46.3134C19.5757 45.643 20.1184 45.1035 20.7923 45.1035H46.3442C47.0149 45.1035 47.5587 45.6441 47.5587 46.3134V62.4491Z",
    fill: "url(#paint9_linear_254_7176)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6637 56.3727C35.2032 55.4585 35.6116 55.2346 35.637 54.2887C35.6444 54.2507 35.6444 54.2169 35.6444 54.1779C35.6444 53.0356 34.7123 52.1055 33.5677 52.1055C32.4219 52.1055 31.491 53.0356 31.491 54.1779C31.491 54.2159 31.491 54.2496 31.492 54.2887C31.5217 55.2336 31.9311 55.4574 32.4706 56.3727C32.5954 56.5839 32.6293 56.7992 32.6399 56.9513H32.4304V57.4791H32.6568C32.6462 57.5055 32.6388 57.5404 32.6388 57.5752C32.6388 57.6512 32.6727 57.7219 32.7298 57.7758C32.6727 57.8307 32.6388 57.8972 32.6388 57.9753C32.6388 58.0503 32.6695 58.1189 32.7235 58.1706C32.6695 58.2202 32.6388 58.2794 32.6388 58.3459C32.6388 58.4705 32.7509 58.5771 32.9117 58.6088C32.9932 58.841 33.2556 59.0089 33.5677 59.0089C33.8787 59.0089 34.1432 58.841 34.2214 58.6088C34.3812 58.5771 34.4976 58.4705 34.4976 58.3459C34.4976 58.2794 34.4637 58.2202 34.4108 58.1706C34.4637 58.1189 34.4976 58.0513 34.4976 57.9753C34.4976 57.8982 34.4616 57.8307 34.4024 57.7758C34.4616 57.7209 34.4976 57.6512 34.4976 57.5752C34.4976 57.5404 34.4902 57.5066 34.4764 57.4791H34.706V56.9513H34.4965C34.5007 56.7992 34.5388 56.5839 34.6637 56.3727Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8026 51.5898C33.8026 51.7587 33.6968 51.8981 33.5667 51.8981C33.4355 51.8981 33.3318 51.7587 33.3318 51.5898V50.5668C33.3318 50.399 33.4355 50.2617 33.5667 50.2617C33.6968 50.2617 33.8026 50.399 33.8026 50.5668V51.5898Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3744 51.7746C32.4632 51.9214 32.4378 52.0935 32.3257 52.1568C32.2167 52.2244 32.0538 52.1557 31.9671 52.009L31.4571 51.1253C31.3746 50.9786 31.3947 50.8023 31.5079 50.7411C31.6211 50.6777 31.7819 50.7421 31.8666 50.891L32.3744 51.7746Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.234 52.6533C31.3811 52.7357 31.4477 52.8983 31.3842 53.0049C31.3176 53.1221 31.1462 53.1442 30.9992 53.0566L30.1137 52.5478C29.9666 52.4633 29.8989 52.3039 29.9645 52.192C30.0291 52.079 30.2015 52.0547 30.3464 52.1445L31.234 52.6533Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.687 53.9766C30.8541 53.9766 30.9895 54.0842 30.9895 54.2109C30.9895 54.3429 30.8541 54.4464 30.687 54.4464H29.6629C29.4926 54.4464 29.3572 54.3429 29.3572 54.2109C29.3572 54.0842 29.4926 53.9766 29.6629 53.9766H30.687Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8741 55.4014C31.0233 55.3138 31.1957 55.3423 31.2592 55.4499C31.3238 55.565 31.256 55.7244 31.1069 55.8089L30.2214 56.3178C30.0754 56.4033 29.9019 56.3811 29.8395 56.2713C29.7771 56.1594 29.8395 55.9989 29.9876 55.9134L30.8741 55.4014Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5968 56.494C31.6645 56.3726 31.8126 56.3293 31.9248 56.3916C32.0359 56.457 32.0739 56.607 32.0031 56.7273L31.582 57.4515C31.5111 57.5751 31.3641 57.6183 31.2498 57.5518C31.1398 57.4874 31.1038 57.3407 31.1758 57.2193L31.5968 56.494Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.759 51.7746C34.6733 51.9214 34.6955 52.0935 34.8077 52.1568C34.9198 52.2244 35.0785 52.1557 35.1642 52.009L35.6773 51.1253C35.763 50.9786 35.7397 50.8023 35.6307 50.7411C35.5165 50.6777 35.3557 50.7421 35.2732 50.891L34.759 51.7746Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8983 52.6533C35.7523 52.7357 35.6845 52.8983 35.7491 53.0049C35.8157 53.1221 35.9871 53.1442 36.1331 53.0566L37.0175 52.5478C37.1656 52.4633 37.2323 52.3039 37.1699 52.192C37.1032 52.079 36.9297 52.0547 36.7879 52.1445L35.8983 52.6533Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4495 53.9766C36.2802 53.9766 36.1416 54.0842 36.1416 54.2109C36.1416 54.3429 36.2802 54.4464 36.4495 54.4464H37.4714C37.6428 54.4464 37.7771 54.3429 37.7771 54.2109C37.7771 54.0842 37.6428 53.9766 37.4714 53.9766H36.4495Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.26 55.4014C36.1119 55.3138 35.9395 55.3423 35.8739 55.4499C35.8115 55.565 35.8771 55.7244 36.0252 55.8089L36.9106 56.3178C37.0566 56.4033 37.228 56.3811 37.2925 56.2713C37.3571 56.1594 37.2925 55.9989 37.1444 55.9134L36.26 55.4014Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5377 56.494C35.47 56.3726 35.3218 56.3293 35.2087 56.3916C35.0976 56.457 35.0616 56.607 35.1325 56.7273L35.5535 57.4515C35.6223 57.5751 35.7715 57.6183 35.8847 57.5518C35.9926 57.4874 36.0296 57.3407 35.9598 57.2193L35.5377 56.494Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_254_7176",
    x1: 43.643,
    y1: 47.0209,
    x2: 43.643,
    y2: 28.2024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DDEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1864,
    stopColor: "#A2DFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4064,
    stopColor: "#B0E4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6431,
    stopColor: "#C8EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8902,
    stopColor: "#E9F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_254_7176",
    x1: 23.4238,
    y1: 47.0209,
    x2: 23.4238,
    y2: 28.2024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DDEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1864,
    stopColor: "#A2DFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4064,
    stopColor: "#B0E4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6431,
    stopColor: "#C8EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8902,
    stopColor: "#E9F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_254_7176",
    x1: 33.5338,
    y1: 26.5862,
    x2: 33.5338,
    y2: 2.06012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0242,
    stopColor: "#F7BB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_254_7176",
    x1: 36.4872,
    y1: 33.9244,
    x2: 36.4872,
    y2: 28.2024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DDEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1864,
    stopColor: "#A2DFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4064,
    stopColor: "#B0E4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6431,
    stopColor: "#C8EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8902,
    stopColor: "#E9F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_254_7176",
    x1: 30.5798,
    y1: 33.9244,
    x2: 30.5798,
    y2: 28.2024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DDEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1864,
    stopColor: "#A2DFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4064,
    stopColor: "#B0E4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6431,
    stopColor: "#C8EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8902,
    stopColor: "#E9F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_254_7176",
    x1: 33.5343,
    y1: 45.3616,
    x2: 33.5343,
    y2: 30.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EA814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#62A914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    stopColor: "#6DAD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9721,
    stopColor: "#7FB410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B510"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_254_7176",
    x1: 47.5077,
    y1: 64.4346,
    x2: 47.5077,
    y2: 30.2193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#062A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2719,
    stopColor: "#072C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5179,
    stopColor: "#083263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7539,
    stopColor: "#0B3C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#104B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_254_7176",
    x1: 19.5621,
    y1: 64.4346,
    x2: 19.5621,
    y2: 30.2193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#062A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2719,
    stopColor: "#072C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5179,
    stopColor: "#083263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7539,
    stopColor: "#0B3C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#104B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_254_7176",
    x1: 19.5756,
    y1: 64.4924,
    x2: 47.5588,
    y2: 64.4924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0242,
    stopColor: "#FF7D01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6742,
    stopColor: "#FFAB0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_254_7176",
    x1: 33.5672,
    y1: 63.6634,
    x2: 33.5672,
    y2: 45.1026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DDEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1739,
    stopColor: "#A4E0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#B8E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7328,
    stopColor: "#D8F0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCybericon);
export default __webpack_public_path__ + "static/media/cyber icon.056cfd6fd95fb106979bf3c18dc497bf.svg";
export { ForwardRef as ReactComponent };